module.exports = __webpack_public_path__ + "img/co.d5610a04.jpg";